import React from "react";
import Cup from "../Cup/Cup";
import PirateFlag from "../PirateFlag/PirateFlag";
import { useQubiqRepublicVisual } from "../../hooks/useQubiqRepublicVisual";

const QubiqRepublicVisual = ({ isYellow = false }) => {
  const { showPirateFlag } = useQubiqRepublicVisual();

  if (showPirateFlag) {
    return <PirateFlag isYellow={isYellow} />;
  }

  return <Cup isYellow={isYellow} />;
};

export default QubiqRepublicVisual;
